import { useContext, useEffect, useRef, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import { Checkbox } from '@mui/material'
import { IoIosAddCircleOutline } from 'react-icons/io'
import { toast } from 'react-toastify'
import { ButtonSubmit, Content, Title } from '../../GlobalStyle'
import Component from '../components/Component'
import Header from '../components/Header'
import ModalAddProduct from '../components/Modal/ModalAddProduct'
import PopUp from '../components/Modal/PopUpAddProduct'
import {
  BarCodeContainer,
  ButtonDiv,
  Components,
  ComponentsDiv,
  FormProduct,
  InputGrid,
  ItemGrid,
  PageContainer,
  PlataformTable,
  SectionSpacing,
  Tbody,
  Thead,
  ToggleDiv,
  TopBar,
  TotalGrid,
} from './style'

import { Line } from '../components/Line'

import { ProgressSpinner } from 'primereact/progressspinner'
import { BiBarcodeReader } from 'react-icons/bi'
import { useQuery } from 'react-query'
import FormDataContext from '../../context/CreateProductsContext'
import { ModalTotalContext } from '../../context/ModalContext'
import api from '../../hooks/API'
import { cost_unity, gainCalculated, rival, sell } from '../../hooks/Calculations'
import { formatedPercent } from '../../hooks/FormatedPercent'
import { Mask } from '../../hooks/Mask'
import { CurrencyInput } from '../../hooks/MaskInput'
import { useAddComponent, useAddProduct } from '../../hooks/mutations'
import { reverseFormatMoney, reverseFormatPercent } from '../../hooks/removeFormat'
import BarReader from '../components/BarReader'
import BoxShadow from '../components/BoxShadowDiv'
import CheckBoxMade from '../components/CheckBox'
import InputComponent from '../components/Input'
import SelectOptions from '../components/Select'
import { Toggle } from '../components/ToggleButton'

const CreatedProducts = () => {
  const location = useLocation()
  const childRef = useRef(null)
  const { state: path } = location
  const [state, setState] = useState(JSON.parse(localStorage.getItem('isLikeComponent')))

  let fixas = 0
  let variaveis = 0

  const navigate = useNavigate()
  const { mutate: addComponent } = useAddComponent()
  const { mutate: addProduct } = useAddProduct()
  const [autoId, setAutoId] = useState(true)

  const { data: productsResponse, isLoading } = useQuery(['components'], () => api.getProducts())
  const {
    data: profileResponse,
    isSuccess,
    isLoading: isLoadingExpenses,
  } = useQuery(['profile'], () => api.getProfile())
  const {
    data: plataformsResponse,
    isSuccess: isSuccessPlataform,
    isLoading: isLoadingProfile,
  } = useQuery(['plataforms'], () => api.getPlataforms())

  const products = Array.isArray(productsResponse)
    ? productsResponse
    : Array.isArray(productsResponse?.data)
      ? productsResponse.data
      : []

  const plataforms = Array.isArray(plataformsResponse)
    ? plataformsResponse
    : Array.isArray(plataformsResponse?.data)
      ? plataformsResponse.data
      : []

  if (isSuccess) {
    fixas = profileResponse?.despesas_fixas || 0
    variaveis = profileResponse?.despesas_variaveis || 0
  }

  useEffect(() => {
    if (isSuccessPlataform) {
      const { id } = plataforms.filter((plataform) => plataform.nome === 'Balcão')[0] || {
        id: null,
      }

      if (id !== null) handleChange(id)
    }
  }, [isSuccessPlataform])

  const [JSONBackProduct, setJSONBackProduct] = useState({})
  const [selectedPlataform, setSelectPlataform] = useState([])
  const { openModal, setOpenModal } = useContext(ModalTotalContext)

  const { values, updateFormField, clearForm } = useContext(FormDataContext)
  const [components, setComponents] = useState(values.components || [])

  const costUnique = cost_unity(values.totalCost, values.quantidade)

  const handle = (e, value) => {
    e.preventDefault()

    if (e.target.name === 'quantidade') {
      updateFormField('price', sell(values.totalCost / value, values.gain, 0, fixas, variaveis))
    }
    if (e.target.name === 'gain') {
      updateFormField('price', sell(costUnique, value, 0, fixas, variaveis))
    }
    if (e.target.name === 'price') {
      updateFormField('gain', gainCalculated(costUnique, value, fixas, variaveis))
    }

    updateFormField(e.target.name, value)
  }

  const ref = useRef()

  const clear = () => {
    clearForm()
    setComponents([])
    localStorage.removeItem('form')
  }

  const madeProdut = async (e) => {
    e.preventDefault()

    const product = ref.current

    if (
      !product?.nome.value ||
      !product?.price.value ||
      !product?.gain.value ||
      selectedPlataform.length <= 0 ||
      (!(state == true) ? !(components.length > 0) : false)
    ) {
      toast.warn('Usuário Teste - Demonstração')
    } else {
      const selectedPlatformsData = plataforms.filter((p) => selectedPlataform.includes(p.id))

      selectedPlatformsData.map((select) => {
        select.preco_zero = sell(costUnique, 0, select.despesas, fixas, variaveis)
        select.preco_venda = sell(costUnique, values.gain, select.despesas, fixas, variaveis)
        return select
      })

      const JSON = {
        id: values.id,
        nome: values.nome,
        quantidade: values.quantidade,
        preco_custo: values.totalCost,
        components,
        unidade: values.unidade,
        lucro: values.gain,
        preco_venda: values.price * values.quantidade,
        plataformas: selectedPlatformsData,
        codigo_barras: product?.codigo_barras?.value,
      }

      setJSONBackProduct({
        id: values.id,
        nome: values.nome,
        unidade: values.unidade,
        quantidade: values.quantidade,
        valor: values.totalCost,
      })

      addProduct(JSON)
      clear()
      navigate(location.pathname)

      if (!state) setOpenModal('prodAsComponent')
    }
  }

  const addProductAsComponent = () => {
    addComponent(JSONBackProduct)
  }

  useEffect(() => {
    if (components?.length >= 0 && !(path && state)) {
      let sum = 0
      components.forEach((prod) => {
        sum += prod.quantidade * prod.valor_unit
      })
      updateFormField('components', components)
      updateFormField('totalCost', sum)
    }
  }, [components, path, state])

  const deleteComponent = (id) => {
    const newComponents = components.filter((item) => item.id !== id)
    setComponents(newComponents)
  }

  useEffect(() => {
    updateFormField(
      'price',
      sell(costUnique, reverseFormatPercent(values.gain), 0, fixas, variaveis)
    )
    updateFormField('gain', 0)
  }, [values.totalCost])

  const isFound = (id) => selectedPlataform.some((idSelected) => idSelected === id)

  const handleChange = (id) => {
    isFound(id)
      ? setSelectPlataform(selectedPlataform.filter((plat) => plat !== id))
      : setSelectPlataform((old) => [...old, id])
  }

  if (isLoading || isLoadingExpenses || isLoadingProfile) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          minHeight: '50vh',
        }}
      >
        <ProgressSpinner size="6rem" />
      </div>
    )
  }

  const handleScan = () => {
    setOpenModal('scan')
    childRef.current?.handleClickAdvanced()
  }

  const toggle = () => {
    clear()
    setState(!state)
    localStorage.setItem('isLikeComponent', !state)
    navigate(location.pathname, { replace: true })
  }

  return (
    <>
      <Content>
        <PageContainer>
          <Title>Criar produtos</Title>

          <SectionSpacing>
            <TopBar>
              <ToggleDiv>
                <p>Componetização</p>
                <Toggle toggled={state} onClick={() => toggle()} />
                <p>Produção</p>
              </ToggleDiv>
            </TopBar>
          </SectionSpacing>

          <SectionSpacing>
            <BoxShadow margin="0">
              <Header title="Campos dados pelo usuário" />

              <FormProduct ref={ref} onSubmit={madeProdut}>
                <TotalGrid>
                  <InputGrid>
                    <div>
                      <InputComponent
                        placeholder="Ex: 001"
                        name="id"
                        value={values.id}
                        onChange={(e) => handle(e, e.target.value)}
                        disabled={autoId}
                        label="Código"
                      />
                      <CheckBoxMade className="idDiv" setAutoId={setAutoId} autoId={autoId} />
                    </div>

                    <InputComponent
                      placeholder="Ex: Purê de batata"
                      name="nome"
                      className="name"
                      onChange={(e) => handle(e, e.target.value)}
                      value={values.nome}
                      label="Nome do produto *"
                      disabled={state && path}
                    />

                    {!(state && !path) && (
                      <>
                        <SelectOptions
                          disabled={state && path}
                          handle={handle}
                          unity={values.unidade}
                          className="defaultSize"
                        />

                        <ItemGrid>
                          <InputComponent
                            value={values.quantidade}
                            onChange={(e) => handle(e, Mask.onlyDigits(e.target.value))}
                            name="quantidade"
                            placeholder="Ex: 2"
                            label="Quantidade *"
                            disabled={state && path}
                          />
                        </ItemGrid>
                      </>
                    )}

                    <CurrencyInput
                      name="gain"
                      currency="percent"
                      className={!(state && !path) ? 'defaultSize' : null}
                      value={values.gain}
                      onChangeValue={(e, originalValue) => {
                        handle(e, originalValue)
                      }}
                      placeholder="Ex: 10%"
                      label="Lucro esperado *"
                    />

                    <CurrencyInput
                      name="price"
                      className="defaultSize"
                      placeholder="R$ 0,00"
                      value={values.price}
                      onChangeValue={(e, originalValue) => {
                        handle(e, originalValue)
                      }}
                      label="Preço praticado *"
                    />

                    <CurrencyInput
                      name="rival"
                      className="defaultSize"
                      onChangeValue={(e, originalValue) => handle(e, originalValue)}
                      value={values.rival}
                      placeholder="R$ 0,000"
                      label="Preço do concorrente"
                    />

                    <CurrencyInput
                      name="totalCost"
                      value={costUnique}
                      onChangeValue={(e, originalValue) =>
                        !path && state ? handle(e, originalValue) : null
                      }
                      placeholder="R$ 0,00"
                      className="defaultSize"
                      label="Custo por produto"
                      disabled={!(!path && state)}
                    />

                    <InputComponent
                      placeholder="0%"
                      className="defaultSize"
                      value={Mask.percent(
                        rival(0, reverseFormatMoney(values.rival), fixas, variaveis, costUnique)
                      )}
                      label="Concorrente"
                      disabled
                    />
                  </InputGrid>

                  <Line />

                  {state && (
                    <BarCodeContainer>
                      <InputComponent
                        name="codigo_barras"
                        height="44px"
                        label="Código de barras"
                        placeholder="Insira ou escaneie o código"
                      />
                      <button type="button" className="barcodeButton" onClick={() => handleScan()}>
                        <BiBarcodeReader />
                      </button>
                    </BarCodeContainer>
                  )}

                  {!state && (
                    <ComponentsDiv>
                      <ButtonDiv>
                        <ButtonSubmit
                          margin="15px 0px 0px 0px"
                          onClick={() => setOpenModal('addComp')}
                          type="button"
                          rounded
                        >
                          <IoIosAddCircleOutline />
                          &nbsp; Adicionar componentes
                        </ButtonSubmit>
                      </ButtonDiv>

                      <Components>
                        {components?.map((item) => {
                          return (
                            <Component
                              id={item.id}
                              deleteComponent={deleteComponent}
                              key={item.id}
                              title={item.nome}
                              quantidade={item.quantidade}
                              unidade={item.unidade}
                            />
                          )
                        })}
                      </Components>
                    </ComponentsDiv>
                  )}

                  <ButtonSubmit margin="20px 0px 0px 0px" type="submit" width="100%" height="48px">
                    Criar produto
                  </ButtonSubmit>
                </TotalGrid>
              </FormProduct>
            </BoxShadow>
          </SectionSpacing>

          <SectionSpacing>
            <BoxShadow margin="0">
              <Header title="Plataformas" />

              <TotalGrid>
                <div style={{ textAlign: 'start' }}>
                  <PlataformTable>
                    <Thead>
                      <tr>
                        <th style={{ width: '40%' }}>Plataforma</th>
                        <th style={{ width: '20%' }}>Preço</th>
                        <th style={{ width: '20%' }}>Lucro do concorrente</th>
                        <th style={{ width: '20%' }}>Preço zero</th>
                      </tr>
                    </Thead>

                    <Tbody>
                      {plataforms.length === 0 && (
                        <tr>
                          <td colSpan={4} className="emptyState">
                            <strong>Nenhuma plataforma cadastrada</strong>
                            <span>Cadastre ou carregue plataformas para visualizar os cálculos.</span>
                          </td>
                        </tr>
                      )}

                      {plataforms.map((plataform) => {
                        return (
                          <tr key={plataform.id}>
                            <td data-label="Nome da plataforma">
                              <Checkbox
                                className="check"
                                defaultChecked={plataform.nome === 'Balcão'}
                                onChange={() => handleChange(plataform.id)}
                                color="success"
                                sx={{ width: '24px', height: '24px', padding: '0px 3px 0px 0px' }}
                              />
                              <span style={{ verticalAlign: 'middle' }}>{plataform.nome}</span>
                            </td>

                            <td className="price" data-label="Preço de venda">
                              {Mask.money(
                                sell(costUnique, values.gain, plataform.despesas, fixas, variaveis)
                              )}
                            </td>

                            <td data-label="Lucro do concorrente">
                              {formatedPercent(
                                rival(
                                  plataform.despesas,
                                  reverseFormatMoney(values.rival),
                                  fixas,
                                  variaveis,
                                  costUnique
                                )
                              )}
                            </td>

                            <td data-label="Preço zero">
                              {Mask.money(sell(costUnique, 0, plataform.despesas, fixas, variaveis))}
                            </td>
                          </tr>
                        )
                      })}
                    </Tbody>
                  </PlataformTable>
                </div>
              </TotalGrid>
            </BoxShadow>
          </SectionSpacing>
        </PageContainer>
      </Content>

      {openModal === 'addComp' && (
        <ModalAddProduct
          setComponents={setComponents}
          components={components}
          products={products}
        />
      )}

      {openModal === 'prodAsComponent' && <PopUp callBack={addProductAsComponent} />}
      {<BarReader product={ref} ref={childRef} />}
    </>
  )
}

export default CreatedProducts